import * as React from "react";
const SvgFiRrTransformationDesign = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-transformation-design_svg__a)">
      <path
        fill="#062147"
        d="M5 23a1 1 0 0 1-1 1c-2.206 0-4-1.794-4-4a1 1 0 1 1 2 0c0 1.103.897 2 2 2a1 1 0 0 1 1 1M4 0C1.794 0 0 1.794 0 4a1 1 0 1 0 2 0c0-1.103.897-2 2-2a1 1 0 1 0 0-2M1 11a1 1 0 0 0 1-1V8a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1m0 6a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1M23.939 4.887 20.48 20.109a4.975 4.975 0 0 1-4.875 3.892h-4.643a3.98 3.98 0 0 1-3.126-1.505 3.98 3.98 0 0 1-.774-3.382l3.459-15.222A4.975 4.975 0 0 1 15.396 0h4.643a3.98 3.98 0 0 1 3.126 1.505 3.98 3.98 0 0 1 .774 3.382m-2.337-2.135A1.99 1.99 0 0 0 20.039 2h-4.643c-1.41 0-2.613.96-2.925 2.335L9.012 19.557a1.99 1.99 0 0 0 .387 1.691c.381.478.951.752 1.563.752h4.643c1.41 0 2.613-.96 2.925-2.335l3.459-15.222a1.99 1.99 0 0 0-.387-1.691M8 2h1.115a1 1 0 1 0 0-2H8a1 1 0 1 0 0 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-transformation-design_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTransformationDesign;
